import { axiosInstance } from '../context/AuthContext';

export const galleryFollowApi = {
  toggleFollow: async (galleryId) => {
    const response = await axiosInstance.post('/user/gallery-follows/toggle', {
      galleryId,
    });
    return response.data;
  },

  checkFollowing: async (galleryId) => {
    const response = await axiosInstance.get(
      `/user/gallery-follows/check/${galleryId}`
    );
    return response.data;
  },
};
